/**
 * Firebase configuration module.
 * Handles initialization and configuration of Firebase services.
 *
 * @module firebase/config
 */

import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

/**
 * Firebase configuration object
 * @type {Object}
 */
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

/**
 * Firebase app instance
 * @type {import('firebase/app').FirebaseApp}
 */
export const app = initializeApp(firebaseConfig);

/**
 * Firebase Realtime Database instance
 * @type {import('firebase/database').Database}
 */
export const db = getDatabase(app);
